import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-routing-machine';
import '../map.css';
import axios from 'axios';
import { colors } from '../color';
import {  AlertFilled, AlertOutlined } from '@ant-design/icons';
import {  PlusOutlined,} from '@ant-design/icons';
import { FaCrosshairs,  } from 'react-icons/fa';
import { ServerIP } from '../component/ServerIP';
import { io } from 'socket.io-client';





const ClientDriverConnectMap = ({ }) => {

    const params = new URLSearchParams(window.location.search);
    const driverIdUrl = params.get('driverId');
    const driverId = params.get('driverId');


    //Map

    const mapContainer = useRef(null);
    const map = useRef(null);
    const center = { lat: 18.6565184, lng: -72.3156992 };
    const [location, setLocation] = useState([18.32, -72.17]);

    const [zoom] = useState(12);

    useEffect(() => {
        if (map.current) return;

        map.current = new L.Map(mapContainer.current, {
            center: L.latLng(center.lat, center.lng),
            zoom: zoom,
            zoomControl: false,
        });


        L.tileLayer('https://api.maptiler.com/maps/streets-v2/style.json?key=wpyZbJOc6hFpTL8ANsqV', {
            // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 20,
            minZoom: 3,
        }).addTo(map.current);

        fetchNearbyMarker();
        getRoute();

    }, [center.lat, center.lng, zoom]);


    //Alert

    const userMarkerRef = useRef(null);
    const [alertMarker, setAlertMarker] = useState([]);
    const [oldAlertMarker, setOldAlertMarker] = useState([]);
    const [showMarker, setShowMarker] = useState(true);

    function getColor(title) {
        switch (title) {
            case 'Tir':
                return 'rgba(255,0,0,0.5)';
            case 'Kidnapping':
                return 'rgba(230, 126, 34, 0.5)';
            case 'Blocked':
                return 'gray';
            default:
                return 'black';
        }
    }

    function getIcon(title) {
        switch (title) {
            case 'Tir':
                return L.icon({ iconUrl: require('../data/IconImageMap/gun.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Kidnapping':
                return L.icon({ iconUrl: require('../data/IconImageMap/child.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Blocked':
                return L.icon({ iconUrl: require('../data/IconImageMap/block1.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            default:
                return L.icon({ iconUrl: require('../data/IconImageMap/block.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
        }
    }

    function getRadius(title) {
        switch (title) {
            case 'Tir':
                return 400;
            case 'Kidnapping':
                return 600;
            case 'Blocked':
                return 100;
            default:
                return 100;
        }
    }

    const markersRef = useRef([]);
    const circlesRef = useRef([]);


    useEffect(() => {
        if (Array.isArray(alertMarker) && alertMarker.length > 0) {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];

            alertMarker.map((marker, index) => {
                if (marker.coordinate) {
                    const icon = getIcon(marker.title);
                    const markerInstance = L.marker([marker.coordinate.latitude, marker.coordinate.longitude], { icon }).addTo(map.current);
                    markerInstance.bindPopup(`${marker.title} - ${getTime(marker.createdAt)}`);

                    const circle = L.circle([marker.coordinate.latitude, marker.coordinate.longitude], { radius: getRadius(marker.title), fillColor: getColor(marker.title), fillOpacity: 0.2, color: getColor(marker.title) }).addTo(map.current);

                    // Ajoutez les instances de marqueurs et de cercles aux tableaux
                    markersRef.current.push(markerInstance);
                    circlesRef.current.push(circle);
                }
            });
        } else {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];
        }
    }, [alertMarker]);


    const fetchNearbyMarker = async () => {

        await axios.get(`${ServerIP}/alert/getAlert`)
            .then(res => {

                setAlertMarker(res.data.alertMarker);

                setOldAlertMarker(res.data.alertMarker);

            })
    };


    const getTime = (time) => {
        var date = new Date(time);
        var maintenant = new Date();
        var difference = Math.abs(maintenant - date); // en millisecondes

        var minutes = Math.floor(difference / 60000);
        if (minutes < 60) {
            return minutes + " min";
        } else {
            var heures = Math.floor(minutes / 60);
            return heures + " h";
        }

    };

    const cancelShowMarker = () => {
        setShowMarker(false);
        setAlertMarker([])
    }

    const showMarkerFunc = () => {
        setShowMarker(true);
        setAlertMarker(oldAlertMarker);
    }



    //Routing

    let userMarker = useRef()
    let userMarker2 = useRef()

    const getRoute = async () => {
        try {
            const res = await axios.get(`${ServerIP}/mission/getCoordinateMission/${driverIdUrl}`);
            if (res.status === 200) {
                const pickupLatitude = res.data.pickupLatitude;
                const pickupLongitude = res.data.pickupLongitude;
                const deliveredLatitude = res.data.deliveredLatitude;
                const deliveredLongitude = res.data.deliveredLongitude;

                  //pickup
                  const userIcon2 = L.icon({
                    iconUrl: require('../data/IconImageMap/riseHand.png'),
                    iconSize: [25, 36],
                    iconAnchor: [12, 35]
                });

                if (userMarker2.current) {
                    userMarker2.current.remove();
                }

                userMarker2.current = L.marker([res.data.pickupLatitude, res.data.pickupLongitude],
                    { icon: userIcon2 }).addTo(map.current);


                //delivered
                setLocation([res.data.deliveredLatitude, res.data.deliveredLongitude]);

                if (userMarker.current) {
                    userMarker.current.remove();
                }

                userMarker.current = L.marker([res.data.deliveredLatitude, res.data.deliveredLongitude], {
                    icon: L.icon({
                        iconUrl: require('../data/IconImageMap/Location2.png'),
                        iconSize: [30, 41],
                        iconAnchor: [12, 41]
                    }),
                    draggable: false
                }).addTo(map.current);
    
                // Calculate route using TomTom Routing API
                const response = await axios.get(`https://api.tomtom.com/routing/1/calculateRoute/${pickupLatitude},${pickupLongitude}:${deliveredLatitude},${deliveredLongitude}/json`, {
                    params: {
                        key: process.env.REACT_APP_TOMTOM_API,
                        traffic: false
                    }
                });
    
                if (response.data.routes.length > 0) {
                    const coordinates = response.data.routes[0].legs[0].points.map(point => [point.latitude, point.longitude]);
                    console.log(coordinates);
    
                    const latLngs = coordinates.map(coord => L.latLng(coord[0], coord[1]));
                    console.log(latLngs);
    
                    const polyline = L.polyline(latLngs, {
                        color: colors.secondary,
                        weight: 5,
                        opacity: 0.8
                    }).addTo(map.current);
    
                } else {
                    console.log('No routes found');
                }

                // map.current.flyTo([pickupLatitude, pickupLongitude], map.current.getZoom() + 2);
            }
        } catch (err) {
            console.log(err);
        }
    };


    //socket
    
    const driverMarkerRef = useRef(null);
    const socketRef = useRef(null);

    useEffect(() => {
        // Connexion Socket.IO
        if (!socketRef.current) {
            socketRef.current = io(process.env.REACT_APP_SERVER_IP, {
                withCredentials: true,
                transports: ["websocket", "polling"],
            });
        }

        socketRef.current.connect();

         socketRef.current.on("connect", () => {
            socketRef.current.emit('joinRoom', driverId);
        });

        socketRef.current.on("receiveLocation", (data) => {
            const { driverId, latitude, longitude, connected } = data;
            
            if (data && data.latitude && data.longitude) {
                
                   const driverIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocationDriver.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 36],
            });

            if (!driverMarkerRef.current) {
                driverMarkerRef.current = L.marker([data.latitude, data.longitude], { icon: driverIcon }).addTo(map.current);
            } else {
                driverMarkerRef.current.setLatLng([data.latitude, data.longitude]);
            }
                
            } else {
                console.error('Données de localisation incorrectes reçues :', data);
            }

        });

        return () => {
            if (socketRef.current) {
                socketRef.current.off('receiveLocation');
                socketRef.current.disconnect();
            }
        };

    }, [driverId]);


    //Coordinate

    const firstCallRef = useRef(true);
    const intervalIdRef = useRef(null);

    useEffect(() => {

        getRealTimePosition();

        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        if (!map.current.getCenter().equals([location[0], location[1]]) && firstCallRef.current === false) {
            map.current.flyTo([location[0], location[1]], map.current.getZoom());
        }

        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
        };

    }, []);

    const getRealTimePositionFunc = async () => {
        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        if (!map.current.getCenter().equals([location[0], location[1]]) && firstCallRef.current === false) {
            map.current.flyTo([location[0], location[1]], map.current.getZoom());
        }
    }


    const getRealTimePosition = async () => {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(resolve, reject, { maximumAge: 5000 });
            });

            const { latitude, longitude } = position.coords;

            setLocation([latitude, longitude]);

            const userIcon = L.icon({
                iconUrl: require('../data/IconImageMap/currentLocation.png'),
                iconSize: [25, 36],
                iconAnchor: [12, 36],
            });

            if (!userMarkerRef.current) {
                userMarkerRef.current = L.marker([latitude, longitude], { icon: userIcon }).addTo(map.current);
            } else {
                userMarkerRef.current.setLatLng([latitude, longitude]);
            }


            if (firstCallRef.current === true) {
                map.current.flyTo([latitude, longitude], map.current.getZoom());
                firstCallRef.current = false;
            }


        } catch (error) {
            console.error('Erreur de géolocalisation:', error);
        }
    };

    const [isPressed, setIsPressed] = useState(false);

    console.log(location)

    return (


        <div className="map-wrap">


            <div style={{ position: 'absolute', width: '100%', height: '100%' }}>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: 25,
                        top: '76%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                        borderWidth: '1px',
                        backgroundColor: isPressed ? colors.white : colors.accent,
                        height: 50,
                        width: 50,
                        borderRadius: '50%',
                        display: 'flex',
                        alignSelf: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'transform 0.1s, background-color 0.1s',
                        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
                    }}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                    onTouchStart={() => setIsPressed(true)}
                    onTouchEnd={() => setIsPressed(false)}
                    onTouchCancel={() => setIsPressed(false)}
                    onClick={getRealTimePositionFunc}
                >
                    <FaCrosshairs size={20} color={colors.black} />
                </div>

                {showMarker ? (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 25,
                            top: '5%',
                            zIndex: 1,
                            borderWidth: '1px',
                            backgroundColor: 'white',
                            height: 50,
                            width: 50,
                            borderRadius: '50%',
                            boxShadow: '0 0 10px #fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={cancelShowMarker}
                    >
                        <AlertFilled style={{ color: colors.secondary }} />
                    </div>
                ) : (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 25,
                            top: '5%',
                            zIndex: 1,
                            borderWidth: '1px',
                            backgroundColor: 'white',
                            height: 50,
                            width: 50,
                            borderRadius: '50%',
                            boxShadow: '0 0 10px #f0f0f0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={showMarkerFunc}
                    >
                        <AlertOutlined style={{ color: colors.black }} />
                    </div>
                )}

                <div
                    style={{
                        position: 'absolute',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        bottom: 0,
                        top: 0,
                        right: 0,
                        left: 0,
                        zIndex: 1,
                        height: 50,
                        width: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <PlusOutlined style={{ color: colors.black, marginLeft: '5px', fontSize: '12px' }} />
                </div>

            </div>



            <div ref={mapContainer} className="map" style={{ zIndex: 0 }} />



        </div >

    )
}

export default ClientDriverConnectMap;


